import React from "react";
import { useTranslation } from "react-i18next";
import { CiCircleCheck } from "react-icons/ci";
import { useNavigate } from "react-router-dom";


const SuccessStep = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleContactSupport = () => {
    navigate("/hints/page/HelpAccordionList");
  };

  return (
    <div className="flex flex-col w-full h-full">
      {/* Main content - centered */}
      <div className="flex flex-col items-center justify-center flex-1">
        <CiCircleCheck className="size-[135px] text-primary" />

        <div className="max-w-md mx-auto mb-5 mt-6 text-center p-4">
          <p className="text-foreground text-base leading-relaxed mb-5">
            {t(
              "book_location.parcel_placement.success.message",
              "You have successfully reserved a locker for your parcel delivery. Kindly check your email for the details to share with the delivery agency."
            )}
          </p>
        </div>
      </div>

      {/* Bottom section */}
      <div className="mt-auto pb-8 text-center">
        <p className="text-sm text-foreground">
          {t("book_location.success.trouble", "Having trouble? ")}
          <span
            className="text-primary cursor-pointer"
            onClick={handleContactSupport}
          >
            {t("book_location.success.contact_support", "Contact support")}
          </span>
        </p>
      </div>
    </div>
  );
};

export default SuccessStep;
